import styled from 'styled-components';
import { Stack } from 'common/design-system/components-v2';

export const AuthMethodSelectorWrapper = styled(Stack)`
    width: 650px;
`;
